import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { storage } from "services/config/storage";

// reset the local storage on startup
storage.destroy.all();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
